import * as React from 'react';
import { connect } from 'react-redux';
import { assign } from '../../../../../shared/Assign';
import { Translate } from '../../../../../shared/LanguageService';
import { handleError } from '../../../../../shared/ErrorCatching';
import OwnerModalForm from './OwnerModalForm';
import { Modal, Button } from 'react-bootstrap';
import notify from '../../../../../shared/feedback/notifications';
import FormInputChangeHandler from '../../../../../shared/form/FormInputChangeHandler';
import IOrderPrivatePackageAddress from '../entities/IOrderPrivatePackageAddress';

export class OrderAddressModal extends React.Component<any, any> {
    formInputChangeHandler: FormInputChangeHandler;
    constructor(props: any) {
        super(props);

        this.state = {
            errors: {},
            creating: false,
            orderOwner: {},
            hasOrderOwner: false
        };
        this.setValue = this.setValue.bind(this);
    }

    setValue(newState: any) {
        this.setState({ orderOwner: newState });
    }

    componentDidMount() {
        this.formInputChangeHandler = new FormInputChangeHandler(
            this.props.orderOwner,
            this.setValue
        );
        this.setState({
            orderOwner: this.props.orderOwner,
            hasOrderOwner: true
        });
    }

    render() {
        if (!this.state.hasOrderOwner) return <div></div>;
        return (
            <div>
                <Modal show={this.props.shouldShowModal} onHide={this.props.closeModal}>
                    <Modal.Header closeButton>
                        <Modal.Title>
                            {Translate('view-order/contact/modal/title/owner')}
                        </Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <OwnerModalForm
                            orderOwner={this.state.orderOwner}
                            onChange={this.formInputChangeHandler.onChange}
                            errors={this.props.errors}
                            isCommercial={this.props.isCommercial}
                        />
                    </Modal.Body>
                    <Modal.Footer>
                        <Button onClick={this.props.closeModal}>
                            {Translate('view-order/contact/modal/footer/button/close')}
                        </Button>
                        <Button
                            disabled={this.state.creating}
                            bsStyle="primary"
                            onClick={() => {
                                this.props.save(this.state.orderOwner);
                            }}
                        >
                            {Translate('view-order/contact/modal/footer/button/save')}
                        </Button>
                    </Modal.Footer>
                </Modal>
            </div>
        );
    }
}

export default connect()(OrderAddressModal);
